
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/syllabus/jst/Syllabus';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var stack1, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, functionType="function", self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.events), {hash:{},inverse:self.noop,fn:self.program(2, program2, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n\n<tr\n  class=\"date detail_list ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.passed), {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.date), {hash:{},inverse:self.noop,fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += " syllabus_";
  if (helper = helpers.type) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.type); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + " ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.subtype), {hash:{},inverse:self.noop,fn:self.program(7, program7, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += " related-";
  if (helper = helpers.related_id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.related_id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1);
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.override), {hash:{},inverse:self.noop,fn:self.program(9, program9, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\"\n  data-workflow-state=\"";
  if (helper = helpers.workflow_state) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.workflow_state); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n  ";
  stack1 = helpers['if'].call(depth0, (data == null || data === false ? data : data.first), {hash:{},inverse:self.noop,fn:self.program(11, program11, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  <td class=\"name";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.last), {hash:{},inverse:self.noop,fn:self.program(16, program16, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\">\n    ";
  stack1 = (helper = helpers.ifEqual || (depth0 && depth0.ifEqual),options={hash:{},inverse:self.program(20, program20, data),fn:self.program(18, program18, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.subtype), "discussion_topic", options) : helperMissing.call(depth0, "ifEqual", (depth0 && depth0.subtype), "discussion_topic", options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.html_url), {hash:{},inverse:self.program(34, program34, data),fn:self.program(32, program32, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.override), {hash:{},inverse:self.noop,fn:self.program(36, program36, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </td>\n  <td class=\"dates";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.last), {hash:{},inverse:self.noop,fn:self.program(16, program16, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\">\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.start_at), {hash:{},inverse:self.program(50, program50, data),fn:self.program(38, program38, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </td>\n</tr>\n";
  return buffer;
  }
function program3(depth0,data) {
  
  
  return " date_passed";
  }

function program5(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += " events_"
    + escapeExpression((helper = helpers.strftime || (depth0 && depth0.strftime),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.date), "%Y_%m_%d", options) : helperMissing.call(depth0, "strftime", (depth0 && depth0.date), "%Y_%m_%d", options)));
  return buffer;
  }

function program7(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "assignment_type_";
  if (helper = helpers.subtype) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.subtype); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1);
  return buffer;
  }

function program9(depth0,data) {
  
  
  return " special_date";
  }

function program11(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n  <td scope=\"row\" rowspan=\"";
  if (helper = helpers.eventCount) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.eventCount); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" valign=\"top\" class=\"day_date\"\n    data-date=\"";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.date), {hash:{},inverse:self.noop,fn:self.program(12, program12, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\">\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.orig_date), {hash:{},inverse:self.noop,fn:self.program(14, program14, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </td>\n  ";
  return buffer;
  }
function program12(depth0,data) {
  
  var helper, options;
  return escapeExpression((helper = helpers.strftime || (depth0 && depth0.strftime),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.date), "%Y_%m_%d", options) : helperMissing.call(depth0, "strftime", (depth0 && depth0.date), "%Y_%m_%d", options)));
  }

function program14(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    "
    + escapeExpression((helper = helpers.tDateToString || (depth0 && depth0.tDateToString),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.orig_date), "medium_with_weekday", options) : helperMissing.call(depth0, "tDateToString", (depth0 && depth0.orig_date), "medium_with_weekday", options)))
    + "\n    ";
  return buffer;
  }

function program16(depth0,data) {
  
  
  return " not_last";
  }

function program18(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("courses.syllabus")
  },data:data},helper ? helper.call(depth0, "discussion_topic_dc85ad4c", "Discussion Topic", options) : helperMissing.call(depth0, "t", "discussion_topic_dc85ad4c", "Discussion Topic", options)))
    + "</span>\n    "
    + escapeExpression((helper = helpers.addIcon || (depth0 && depth0.addIcon),options={hash:{},data:data},helper ? helper.call(depth0, "discussion", options) : helperMissing.call(depth0, "addIcon", "discussion", options)))
    + "\n    ";
  return buffer;
  }

function program20(depth0,data) {
  
  var stack1, helper, options;
  stack1 = (helper = helpers.ifEqual || (depth0 && depth0.ifEqual),options={hash:{},inverse:self.program(23, program23, data),fn:self.program(21, program21, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.subtype), "quiz", options) : helperMissing.call(depth0, "ifEqual", (depth0 && depth0.subtype), "quiz", options));
  if(stack1 || stack1 === 0) { return stack1; }
  else { return ''; }
  }
function program21(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("courses.syllabus")
  },data:data},helper ? helper.call(depth0, "quiz_e0dcce8f", "Quiz", options) : helperMissing.call(depth0, "t", "quiz_e0dcce8f", "Quiz", options)))
    + "</span>\n    "
    + escapeExpression((helper = helpers.addIcon || (depth0 && depth0.addIcon),options={hash:{},data:data},helper ? helper.call(depth0, "quiz", options) : helperMissing.call(depth0, "addIcon", "quiz", options)))
    + "\n    ";
  return buffer;
  }

function program23(depth0,data) {
  
  var stack1, helper, options;
  stack1 = (helper = helpers.ifEqual || (depth0 && depth0.ifEqual),options={hash:{},inverse:self.program(26, program26, data),fn:self.program(24, program24, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.type), "assignment", options) : helperMissing.call(depth0, "ifEqual", (depth0 && depth0.type), "assignment", options));
  if(stack1 || stack1 === 0) { return stack1; }
  else { return ''; }
  }
function program24(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("courses.syllabus")
  },data:data},helper ? helper.call(depth0, "assignment_976578a8", "Assignment", options) : helperMissing.call(depth0, "t", "assignment_976578a8", "Assignment", options)))
    + "</span>\n    "
    + escapeExpression((helper = helpers.addIcon || (depth0 && depth0.addIcon),options={hash:{},data:data},helper ? helper.call(depth0, "assignment", options) : helperMissing.call(depth0, "addIcon", "assignment", options)))
    + "\n    ";
  return buffer;
  }

function program26(depth0,data) {
  
  var stack1, helper, options;
  stack1 = (helper = helpers.ifEqual || (depth0 && depth0.ifEqual),options={hash:{},inverse:self.program(29, program29, data),fn:self.program(27, program27, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.type), "wiki_page", options) : helperMissing.call(depth0, "ifEqual", (depth0 && depth0.type), "wiki_page", options));
  if(stack1 || stack1 === 0) { return stack1; }
  else { return ''; }
  }
function program27(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("courses.syllabus")
  },data:data},helper ? helper.call(depth0, "page_50c4823d", "Page", options) : helperMissing.call(depth0, "t", "page_50c4823d", "Page", options)))
    + "</span>\n    "
    + escapeExpression((helper = helpers.addIcon || (depth0 && depth0.addIcon),options={hash:{},data:data},helper ? helper.call(depth0, "document", options) : helperMissing.call(depth0, "addIcon", "document", options)))
    + "\n    ";
  return buffer;
  }

function program29(depth0,data) {
  
  var stack1, helper, options;
  stack1 = (helper = helpers.ifEqual || (depth0 && depth0.ifEqual),options={hash:{},inverse:self.program(30, program30, data),fn:self.program(18, program18, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.type), "discussion_topic", options) : helperMissing.call(depth0, "ifEqual", (depth0 && depth0.type), "discussion_topic", options));
  if(stack1 || stack1 === 0) { return stack1; }
  else { return ''; }
  }
function program30(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("courses.syllabus")
  },data:data},helper ? helper.call(depth0, "calendar_event_89aadc1c", "Calendar Event", options) : helperMissing.call(depth0, "t", "calendar_event_89aadc1c", "Calendar Event", options)))
    + "</span>\n    "
    + escapeExpression((helper = helpers.addIcon || (depth0 && depth0.addIcon),options={hash:{},data:data},helper ? helper.call(depth0, "calendar-month", options) : helperMissing.call(depth0, "addIcon", "calendar-month", options)))
    + "\n    ";
  return buffer;
  }

function program32(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n    <a href=\"";
  if (helper = helpers.html_url) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.html_url); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</a>\n    ";
  return buffer;
  }

function program34(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n    ";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n    ";
  return buffer;
  }

function program36(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n    <div class=\"special_date_title\">("
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.override)),stack1 == null || stack1 === false ? stack1 : stack1.title)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + ")</div>\n    ";
  return buffer;
  }

function program38(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.due_at), {hash:{},inverse:self.program(41, program41, data),fn:self.program(39, program39, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  return buffer;
  }
function program39(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("courses.syllabus")
  },data:data},helper ? helper.call(depth0, "due_by_c263dc10", "due by", options) : helperMissing.call(depth0, "t", "due_by_c263dc10", "due by", options)))
    + " <span ";
  stack1 = (helper = helpers.unfudge || (depth0 && depth0.unfudge),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.due_at), options) : helperMissing.call(depth0, "unfudge", (depth0 && depth0.due_at), options));
  buffer += escapeExpression((helper = helpers.contextSensitiveDatetimeTitle || (depth0 && depth0.contextSensitiveDatetimeTitle),options={hash:{},data:data},helper ? helper.call(depth0, stack1, options) : helperMissing.call(depth0, "contextSensitiveDatetimeTitle", stack1, options)))
    + ">"
    + escapeExpression((helper = helpers.tTimeHours || (depth0 && depth0.tTimeHours),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.due_at), options) : helperMissing.call(depth0, "tTimeHours", (depth0 && depth0.due_at), options)))
    + "</span>\n    ";
  return buffer;
  }

function program41(depth0,data) {
  
  var stack1;
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.todo_at), {hash:{},inverse:self.program(44, program44, data),fn:self.program(42, program42, data),data:data});
  if(stack1 || stack1 === 0) { return stack1; }
  else { return ''; }
  }
function program42(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("courses.syllabus")
  },data:data},helper ? helper.call(depth0, "to_do_6ac7b2dc", "to do:", options) : helperMissing.call(depth0, "t", "to_do_6ac7b2dc", "to do:", options)))
    + " <span ";
  stack1 = (helper = helpers.unfudge || (depth0 && depth0.unfudge),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.todo_at), options) : helperMissing.call(depth0, "unfudge", (depth0 && depth0.todo_at), options));
  buffer += escapeExpression((helper = helpers.contextSensitiveDatetimeTitle || (depth0 && depth0.contextSensitiveDatetimeTitle),options={hash:{},data:data},helper ? helper.call(depth0, stack1, options) : helperMissing.call(depth0, "contextSensitiveDatetimeTitle", stack1, options)))
    + ">"
    + escapeExpression((helper = helpers.tTimeHours || (depth0 && depth0.tTimeHours),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.todo_at), options) : helperMissing.call(depth0, "tTimeHours", (depth0 && depth0.todo_at), options)))
    + "</span>\n    ";
  return buffer;
  }

function program44(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n    <span ";
  stack1 = (helper = helpers.unfudge || (depth0 && depth0.unfudge),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.start_at), options) : helperMissing.call(depth0, "unfudge", (depth0 && depth0.start_at), options));
  buffer += escapeExpression((helper = helpers.contextSensitiveDatetimeTitle || (depth0 && depth0.contextSensitiveDatetimeTitle),options={hash:{},data:data},helper ? helper.call(depth0, stack1, options) : helperMissing.call(depth0, "contextSensitiveDatetimeTitle", stack1, options)))
    + ">"
    + escapeExpression((helper = helpers.tTimeHours || (depth0 && depth0.tTimeHours),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.start_at), options) : helperMissing.call(depth0, "tTimeHours", (depth0 && depth0.start_at), options)))
    + "</span>\n    ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.same_time), {hash:{},inverse:self.noop,fn:self.program(45, program45, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  return buffer;
  }
function program45(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("courses.syllabus")
  },data:data},helper ? helper.call(depth0, "to_c4c44f4b", "to", options) : helperMissing.call(depth0, "t", "to_c4c44f4b", "to", options)))
    + "\n    <span ";
  stack1 = (helper = helpers.unfudge || (depth0 && depth0.unfudge),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.end_at), options) : helperMissing.call(depth0, "unfudge", (depth0 && depth0.end_at), options));
  buffer += escapeExpression((helper = helpers.contextSensitiveDatetimeTitle || (depth0 && depth0.contextSensitiveDatetimeTitle),options={hash:{},data:data},helper ? helper.call(depth0, stack1, options) : helperMissing.call(depth0, "contextSensitiveDatetimeTitle", stack1, options)))
    + ">\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.same_day), {hash:{},inverse:self.program(48, program48, data),fn:self.program(46, program46, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </span>\n    ";
  return buffer;
  }
function program46(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n      "
    + escapeExpression((helper = helpers.tTimeHours || (depth0 && depth0.tTimeHours),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.end_at), options) : helperMissing.call(depth0, "tTimeHours", (depth0 && depth0.end_at), options)))
    + "\n      ";
  return buffer;
  }

function program48(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n      "
    + escapeExpression((helper = helpers.tEventToString || (depth0 && depth0.tEventToString),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.end_at), "short", "tiny_on_the_hour", options) : helperMissing.call(depth0, "tEventToString", (depth0 && depth0.end_at), "short", "tiny_on_the_hour", options)))
    + "\n      ";
  return buffer;
  }

function program50(depth0,data) {
  
  
  return "\n    &nbsp;\n    ";
  }

  stack1 = helpers.each.call(depth0, (depth0 && depth0.dates), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { return stack1; }
  else { return ''; }
  });
    ;
    
    import brandableCss from '@canvas/brandable-css';

    brandableCss.loadStylesheetForJST({
      id: '1e',
      bundle: 'jst/courses/Syllabus'
    });
  ;
    export default templates[name];
  